import { InputLabel, MenuItem } from '@mui/material';
import { AxiosResponse } from 'axios';
import { memo } from 'react';
import { __ANPR_PERSON_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from '../pmi-select';
import { PmiFormControl } from '../pmi-select/pmi-form-control';

interface TypeResidenceListComponentProps {
  disabled?: boolean;
  value: string;
  onChange: (typeResidence?: string) => void;
  error?: boolean;
  label?: string;
  id?: string;
}

type Key = {
  codice: string;
};

interface TypeResidence {
  key: Key;
  descrizione: string;
}

const TypeResidenceListComponent = ({
  disabled,
  onChange,
  value,
  error,
  label = 'Tipo soggiorno',
  id = 'type-residence',
}: TypeResidenceListComponentProps): React.ReactElement => {
  const [typeResidence] = useHttpFetch<HttpResponseList<TypeResidence>, Array<ItemVM>>(
    `${__ANPR_PERSON_API_URL__}/tipo-soggiorno`,
    {
      onBootstrap: true,
      initialData: [],
      transformer: (response: AxiosResponse<HttpResponseList<TypeResidence>>) => {
        const { data } = response;

        return data?.payload.list.map((item) => ({
          id: item.key?.codice?.toString(),
          value: item.descrizione,
        })) as Array<ItemVM>;
      },
    }
  );

  const list = typeResidence.data as Array<ItemVM>;

  const idTag = `${id}-${label}`;

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={idTag}>
        {label}
      </InputLabel>
      <PmiSelect
        labelId={idTag}
        id={id}
        name={id}
        value={value}
        label={label}
        onChange={(event) => {
          const selectedValue = event.target.value;
          onChange(selectedValue);
        }}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {list?.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

TypeResidenceListComponent.displayName = 'Type residence List component';

const TypeResidenceList = memo(TypeResidenceListComponent);

export default TypeResidenceList as typeof TypeResidenceListComponent;
